(function () {
  function isMobile() {
    return window.matchMedia && window.matchMedia("(max-width: 767px)").matches;
  }

  function normalizeName(str) {
    return (str || "").toString().trim().toLowerCase();
  }

  // Find the best/active "colour" swatch row on the page (avoid duplicates from sticky/modal)
  function findMainSwatchRow(root) {
    var rows = Array.from(root.querySelectorAll(".xo-product-variant .zeal-swatch-row"));

    // Filter out common duplicate areas + hidden rows
    rows = rows.filter(function (row) {
      // ignore sticky / modal duplicates if present
      if (
        row.closest(".sticky-cart, .sticky-variant-modal, .xo-sticky-cart, .xo-sticky-variant-modal") ||
        row.closest("[data-sticky-cart], [data-sticky-variant]")
      ) {
        return false;
      }

      var style = window.getComputedStyle(row);
      if (style.display === "none" || style.visibility === "hidden") return false;

      // also ignore if it has zero size
      var rect = row.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return false;

      return true;
    });

    if (!rows.length) return null;

    // Pick the row with the most visible height in the viewport
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var bestRow = rows[0];
    var bestScore = -1;

    rows.forEach(function (row) {
      var rect = row.getBoundingClientRect();
      var visibleH = Math.max(0, Math.min(rect.bottom, vh) - Math.max(rect.top, 0));
      if (visibleH > bestScore) {
        bestScore = visibleH;
        bestRow = row;
      }
    });

    return bestRow;
  }

  function getMainSwatchInputs(mainRow) {
    if (!mainRow) return [];
    return Array.from(mainRow.querySelectorAll('input.xo-field-color__input[type="radio"]'));
  }

  function getOverlayContainer(productRoot) {
    // This must exist only ONCE (in main-product.liquid)
    return productRoot.querySelector(".main-product__image-content [data-zeal-media-swatches]");
  }

  // Sync overlay selected state by VALUE (not index)
  function syncOverlaySelected(productRoot) {
    if (!isMobile()) return;

    var mainRow = findMainSwatchRow(productRoot);
    if (!mainRow) return;

    var inputs = getMainSwatchInputs(mainRow);
    if (!inputs.length) return;

    var overlay = getOverlayContainer(productRoot);
    if (!overlay) return;

    var buttons = Array.from(overlay.querySelectorAll(".zeal-overlay-swatch"));
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      var value = btn.getAttribute("data-zeal-value");
      if (!value) return;

      var match = inputs.find(function (i) {
        return i.value === value;
      });

      btn.classList.toggle("is-selected", !!(match && match.checked));
    });
  }

  // Jump to first media tile/slide on mobile when colour changes (optional but keeps behaviour consistent)
  function jumpToFirstMedia(root) {
    if (!isMobile()) return;

    var list =
      root.querySelector(".xo-product-info-media-carousel__list") ||
      root.querySelector(".xo-product-info-media-grid") ||
      root.querySelector(".xo-product-info-media-slide__body");

    if (!list) return;

    var scroller =
      list.closest(".xo-gallery") ||
      list.closest(".xo-carousel") ||
      list.parentElement ||
      list;

    try {
      if (scroller && typeof scroller.scrollTo === "function") {
        scroller.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      } else if (scroller) {
        scroller.scrollTop = 0;
        scroller.scrollLeft = 0;
      }
    } catch (e) {}

    var first =
      root.querySelector(".xo-product-info-media-grid__item") ||
      root.querySelector(".xo-carousel-slide") ||
      root.querySelector(".xo-product-info-media-carousel__list > *");

    if (first && typeof first.scrollIntoView === "function") {
      try {
        first.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
      } catch (e) {
        first.scrollIntoView(true);
      }
    }
  }

  function renderOverlayRow(productRoot) {
    if (!isMobile()) return;

    var mainRow = findMainSwatchRow(productRoot);
    if (!mainRow) return;

    var inputs = getMainSwatchInputs(mainRow);
    if (!inputs.length) return;

    var overlay = getOverlayContainer(productRoot);
    if (!overlay) return;

    overlay.innerHTML = "";

    var row = document.createElement("div");
    row.className = "zeal-overlay-row";

    inputs.forEach(function (input, idx) {
      var field = input.closest(".xo-field-color");
      if (!field) return;

      // Clone visuals (circle)
      var visualClone = field.cloneNode(true);

      // Remove real input inside clone
      var cloneInput = visualClone.querySelector("input");
      if (cloneInput) cloneInput.remove();

      // Button wrapper
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "zeal-overlay-swatch";
      btn.setAttribute("data-zeal-index", String(idx));
      btn.setAttribute("data-zeal-value", input.value); // IMPORTANT: use value matching

      // Store swatch name for special styling (onyx)
      var swatchName =
        visualClone.getAttribute("data-swatch-name") ||
        field.getAttribute("data-swatch-name") ||
        normalizeName(input.value);

      if (swatchName) {
        btn.setAttribute("data-swatch-name", swatchName);
      }

      btn.appendChild(visualClone);

      // Our tick
      var tick = document.createElement("span");
      tick.className = "zeal-overlay-tick";
      tick.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path fill="currentColor" d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"></path>' +
        "</svg>";
      btn.appendChild(tick);

      // Initial selected state (based on current row)
      btn.classList.toggle("is-selected", !!input.checked);

      // Click handler
      btn.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          e.stopPropagation();

          // ✅ INSTANT visual feedback
          overlay.querySelectorAll(".zeal-overlay-swatch.is-selected").forEach(function (b) {
            b.classList.remove("is-selected");
          });
          btn.classList.add("is-selected");

          // Click the matching input in the CURRENTLY ACTIVE row (prevents wrong/duplicate radios)
          var activeRow = findMainSwatchRow(productRoot);
          var activeInputs = getMainSwatchInputs(activeRow);
          var targetValue = btn.getAttribute("data-zeal-value");

          var realInput = activeInputs.find(function (i) {
            return i.value === targetValue;
          });

          if (realInput && !realInput.checked) {
            realInput.click();
            try {
              realInput.dispatchEvent(new Event("change", { bubbles: true }));
            } catch (err) {}
          }

          // Re-sync shortly after in case theme updates state async
          setTimeout(function () {
            syncOverlaySelected(productRoot);
            jumpToFirstMedia(productRoot);
          }, 50);
        },
        { passive: false }
      );

      row.appendChild(btn);
    });

    overlay.appendChild(row);

    // final sync after build
    syncOverlaySelected(productRoot);
  }

  function initProduct(productRoot) {
    if (!productRoot || productRoot.__zealOverlayInit) return;
    productRoot.__zealOverlayInit = true;

    function refresh() {
      var overlay = getOverlayContainer(productRoot);
      if (!overlay) return;

      if (!isMobile()) {
        overlay.innerHTML = "";
        return;
      }
      renderOverlayRow(productRoot);
    }

    refresh();

    window.addEventListener("resize", function () {
      clearTimeout(productRoot.__zealResizeT);
      productRoot.__zealResizeT = setTimeout(refresh, 120);
    });

    // Keep overlay in sync when lower swatches change (anywhere)
    productRoot.addEventListener(
      "change",
      function (e) {
        if (!isMobile()) return;

        var t = e.target;
        if (!t) return;

        var isColorInput =
          t.classList &&
          t.classList.contains("xo-field-color__input") &&
          t.type === "radio";

        if (!isColorInput) return;

        setTimeout(function () {
          syncOverlaySelected(productRoot);
          jumpToFirstMedia(productRoot);
        }, 80);
      },
      true
    );

    // Shopify theme editor rerenders
    document.addEventListener("shopify:section:load", function () {
      setTimeout(refresh, 120);
    });
    document.addEventListener("shopify:section:select", function () {
      setTimeout(refresh, 120);
    });
  }

  function init() {
    var productRoots = document.querySelectorAll("xo-product.main-product__product, .main-product__product");
    productRoots.forEach(initProduct);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
